/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2025-01-22 14:01:46.

export interface BuildInfo {
  group: string;
  artifact: string;
  name: string;
  version: string;
  time: string;
  project_build_sourceEncoding: string;
  maven_compiler_source: string;
  maven_compiler_target: string;
  java_version: string;
  source_version: string;
  java_source: string;
  java_target: string;
  developer_node_version: string;
  developer_npm_version: string;
  developer_maven_version: string;
  custom_coder: string;
  custom_description: string;
  custom_copyright: string;
  custom_copyright_link: string;
  custom_developer_os: string;
}

export interface DemoMode {
  isDemoMode: boolean;
}

export interface DepartmentProcessSummary {
  domain: string;
  department: string;
  domainLabel: string;
  departmentLabel: string;
  processName: string;
  processing: number;
  inFinishedState: number;
  inFailState: number;
  actualProgressInPercent: string;
  key: string;
}

export interface DepartmentSummary {
  domain: string;
  department: string;
  domainLabel: string;
  departmentLabel: string;
  processing: number;
  inFinishedState: number;
  inFailState: number;
  key: string;
}

export interface DomainSummary {
  domain: string;
  domainLabel: string;
  processing: number;
  inFinishedState: number;
  inFailState: number;
  key: string;
}

export interface HierarchyResponse {
  hierarchy: string;
}

export interface Histogram {
  entityNames: string;
  bucketNames: string[];
  histogramz: HistogramData[];
}

export interface HistogramData {
  label: string;
  sum: number;
  actuallyFinished: number;
  actualStepProgress: string;
  numberOfSubjectsInFailstate: number;
  data: number[];
}

export interface LoggedInResponse {
  isLoggedIn: boolean;
}

export interface Login {
  userName: string;
  password: string;
}

export interface RequestKey {
  key: string;
}

export interface SourceDetailDto {
  id?: number;
  version?: number;
  headers?: SourceHeaderDto[];
  proxyHost?: string;
  proxyPort?: number;
  basicAuthUsername?: string;
  basicAuthPassword?: string;
}

export interface SourceDto extends Comparable<SourceDto> {
  id?: number;
  version?: number;
  domain: string;
  department: string;
  domainLabel: string;
  departmentLabel: string;
  processName: string;
  requestKey?: RequestKey;
  accessUrl: string;
  sourceDetailDto?: SourceDetailDto;
  disabled: boolean;
  state: State;
}

export interface SourceHeaderDto {
  id?: number;
  version?: number;
  name: string;
  value: string;
}

export interface SourceTestResponseDto extends Comparable<SourceTestResponseDto> {
  state: State;
  execTime: string;
  updatedWhen: string;
  lastSuccessfulFetch: string;
  histogram: Histogram;
  requestKey: RequestKey;
}

export interface UserAndHashedPassword extends UserDetails {
  hash: string;
  userName: string;
}

export interface UserDetails extends Serializable {
}

export interface Comparable<T> {
}

export interface Serializable {
}

export enum State {
  DISABLED = 'DISABLED',
  UNKNOWN = 'UNKNOWN',
  INITIALIZED = 'INITIALIZED',
  DEMO_MODE = 'DEMO_MODE',
  POLLING_INITIALIZED = 'POLLING_INITIALIZED',
  AVAILABLE = 'AVAILABLE',
  NOT_WORKING_URL_BAD = 'NOT_WORKING_URL_BAD',
  HTTP_CODE_NOT_OK = 'HTTP_CODE_NOT_OK',
  NOT_WORKING_NO_DATA = 'NOT_WORKING_NO_DATA',
  NOT_WORKING_NO_CONTENT_TYPE_IN_RESPONSE = 'NOT_WORKING_NO_CONTENT_TYPE_IN_RESPONSE',
  NOT_WORKING_CONNECTION_REFUSED = 'NOT_WORKING_CONNECTION_REFUSED',
  NOT_WORKING_BAD_CONTENT_TYPE_IN_RESPONSE = 'NOT_WORKING_BAD_CONTENT_TYPE_IN_RESPONSE',
  NOT_WORKING_REQUEST_GIVES_UNKNOWN_HOST_EXCEPTION = 'NOT_WORKING_REQUEST_GIVES_UNKNOWN_HOST_EXCEPTION',
  NOT_WORKING_REQUEST_GIVES_HTTP_CONECTION_TIMEOUT_EXCEPTION = 'NOT_WORKING_REQUEST_GIVES_HTTP_CONECTION_TIMEOUT_EXCEPTION',
  NOT_WORKING_REQUEST_GIVES_UNKNOWN_INTERNAL_ERROR_CODE = 'NOT_WORKING_REQUEST_GIVES_UNKNOWN_INTERNAL_ERROR_CODE',
  NOT_WORKING_REQUEST_GIVES_HTTP_TIMEOUT_EXCEPTION = 'NOT_WORKING_REQUEST_GIVES_HTTP_TIMEOUT_EXCEPTION',
  NOT_WORKING_FOR_UNKNOWN_REASON = 'NOT_WORKING_FOR_UNKNOWN_REASON',
  NOT_WORKING_JSON_SYNTAX_EXCEPTION_WHEN_PARSING_RESPONSE = 'NOT_WORKING_JSON_SYNTAX_EXCEPTION_WHEN_PARSING_RESPONSE',
  NOT_WORKING_UNKNOWN_PROBLEM_WHEN_JSON_PARSING_RESPONSE = 'NOT_WORKING_UNKNOWN_PROBLEM_WHEN_JSON_PARSING_RESPONSE',
  NOT_WORKING_GOT_JSON_RESPONSE_BUT_NOTHING_LIKE_A_HISTOGRAM = 'NOT_WORKING_GOT_JSON_RESPONSE_BUT_NOTHING_LIKE_A_HISTOGRAM',
  NOT_WORKING_PROXY_UNREACHABLE_OR_UNKNOWN = 'NOT_WORKING_PROXY_UNREACHABLE_OR_UNKNOWN',
  NOT_WORKING_BAD_RESPONSE_HTTP_CODE = 'NOT_WORKING_BAD_RESPONSE_HTTP_CODE',
}
